import React, { useState } from 'react';
import { Spinner } from '@fluentui/react';
import useAxios from 'axios-hooks';
import { useRouteMatch, useHistory } from 'react-router-dom';
import CobrandEmailSendersTable from '../Components/CobrandEmailSendersTable';
import DeleteModal from "../../../Util/DeleteModal";
import { useBoolean } from '@fluentui/react-hooks';
import ErrorComponent from '../../../Util/ErrorComponent';
import SuccessComponent from '../../../Util/SuccessComponent';

const DefaultPage = () => {
    const [selectedId, setSelectedId] = useState(undefined);
    const [selectedName, setSelectedName] = useState("");
    const history = useHistory();
    const [showSuccess, setShowSuccess] = useState(false);
    const [showError, setShowError] = useState(false);
    const [errorMsg, setErrorMsg] = useState('');
    let { url } = useRouteMatch();
    const [showDeleteModal, { toggle: toggleDeleteModal }] = useBoolean(false);

    const [{ data: cobrandEmailSenders, loading }, refetch] = useAxios("/emails/cobrand-email-senders");

    if (loading) return <Spinner className="absolute-center" label="Loading Cobrand Email Senders..." />;

    return (
        <>
            <SuccessComponent
                successMessage="Cobrand Email Sender Deleted."
                showSuccess={showSuccess}
                setShowSuccess={setShowSuccess}
            />
            <ErrorComponent
                errorMessage={errorMsg}
                showError={showError}
                setShowError={setShowError}
            />
            <CobrandEmailSendersTable
                cobrandEmailSenders={cobrandEmailSenders}
                createOnClick={() => history.push(`${url}/wizard`)}
                editOnClick={(id) => history.push(`${url}/${id}/wizard`)}
                deleteOnClick={(id, name) => {
                    setSelectedId(id);
                    setSelectedName(name || "");
                    toggleDeleteModal();
                }}
                loading={loading}
            />
            <DeleteModal
                showModal={showDeleteModal}
                toggleShowModal={toggleDeleteModal}
                onDelete={() => refetch()}
                setErrorMsg={setErrorMsg}
                setShowError={setShowError}
                setShowSuccess={setShowSuccess}
                deleteUrl={`emails/cobrand-email-sender/${selectedId}`}
                resourceName={selectedName}
                resourceType="cobrand email sender"
                confirmationValue={selectedName || undefined}
            />
        </>
    );
};

export default DefaultPage;
